<template>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Добавить продукт</h3>
        <button type="button" class="close" @click="$emit('hide')" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label>Наименование</label>
          <server-select
            v-model="product"
            endpoint="products/options"
            label="name"
          />
        </div>
      </div>
      <div class="modal-footer d-flex">
        <btn-action
          class="btn btn-outline-primary ml-auto"
          :disabled="!product"
          @click="save"
        >Сохранить</btn-action>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        product: null,
      }
    },
    methods: {
      save () {
        this.$emit('hide', this.product)
      }
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/matrices/product-modal.vue